import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {
  WidgetRecipientChooserV0ArgsDataValue,
  WidgetRecipientChooserV0ArgsHeader,
  WidgetRecipientChooserV0QueryMapped,
  WidgetRecipientChooserV0Value
} from "../v0/models/widget-recipient-chooser-v0-preview.dto";
import {IoniconsOutline} from "@pt/pt-models";

@Component({
  selector: 'pt-wrc-v0-editor',
  template: `
    <div class="pt-wrc-v0-editor">
      <table class='table table-striped table-sm'>
        <thead class='bg-secondary text-white'>
        <tr>
          <th scope='col' class='recipient-col-fix'>{{ header?.recipient }}</th>
          <th scope='col' class='w120-fix'>{{ header?.recipientType }}</th>
          <th scope='col' class='w200-fix'>{{ header?.extraUe }}</th>
          <th scope='col' class="w200-fix">{{ header?.guarantees }}</th>
          <th scope='col' class="w-100">{{ header?.purpose }}</th>
          <th scope='col' class='w40-fix'></th>
        </tr>
        </thead>
        <tbody>
        <pt-wrc-v0-row style='display: contents'
                       *ngFor='let row of rows; let i = index;'
                       [value]='row'
                       [index]="i"
                       [header]='header'
                       [guaranteesRequired]="guaranteesRequired"
                       [guarantees]='guarantees'
                       [recipientEntity]='recipientEntity'
                       [recipientType]='recipientType'
                       [country]='country'
                       [lockedRecipient]="uniqueRecipient ? lockedRecipient : []"
                       (changeRowValue)='updateValue($event, i)'
                       (clickDelete)='deleteRow(i)'>
        </pt-wrc-v0-row>
        <tr class="p-0 m-0">
          <td colspan="6" class="p-0 m-0">
              <span class='btn px-0 btn-sm btn-link w-100 text-center' (click)='addRow()'>
                <pt-icon [key]='IconAdd'></pt-icon>
                {{ 'BUTTON.ADD' | translate }}
              </span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <!--    <p class="px-1">-->
    <!--            <span class='btn px-0 btn-sm btn-link' (click)='addRow()'>-->
    <!--              <pt-icon [key]='IconAdd'></pt-icon>-->
    <!--              {{ 'BUTTON.ADD' | translate }}-->
    <!--            </span>-->
    <!--    </p>-->
  `,
  styleUrls: [`./wrc-v0-editor.component.scss`]
})
export class WrcV0EditorComponent implements OnChanges {

  @Input() header: WidgetRecipientChooserV0ArgsHeader;
  @Input() uniqueRecipient = true;
  @Input() recipientType: WidgetRecipientChooserV0ArgsDataValue[];
  @Input() guarantees: WidgetRecipientChooserV0ArgsDataValue[];
  @Input() recipientEntity: WidgetRecipientChooserV0QueryMapped[];
  @Input() country: string[];
  @Input() value: WidgetRecipientChooserV0Value[];
  @Input() guaranteesRequired = false;
  public rows: WidgetRecipientChooserV0Value[] = []
  public localValue: WidgetRecipientChooserV0Value[] = []
  public lockedRecipient: string[] = [];
  @Output() changeValue = new EventEmitter<WidgetRecipientChooserV0Value[]>();
  IconAdd = IoniconsOutline.plus;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value) {
      if (changes.value.currentValue) {
        this.localValue = JSON.parse(JSON.stringify(changes.value.currentValue));
      } else {
        this.localValue = [];
      }
      this.rows = this.localValue;
    }
    this.align();
  }

  private align() {
    this.lockedRecipient = this.localValue ? this.localValue.map(r => r.recipient)?.filter(f => !!f) || [] : []
  }

  deleteRow(index: number) {
    this.localValue = this.localValue?.filter((v, i) => i !== index);
    this.changeValue.emit(this.localValue);
    this.rows = this.localValue
    this.align();
  }

  updateValue(value: WidgetRecipientChooserV0Value, index: number) {
    const newValue = [];
    this.localValue?.forEach((v, i) => {
      if (i === index) {
        newValue.push(value);
      } else {
        newValue.push(v);
      }
    });
    this.localValue = JSON.parse(JSON.stringify(newValue));
    this.changeValue.emit(this.localValue);
    this.align();
  }
  addRow() {
    const newValue: WidgetRecipientChooserV0Value[] = JSON.parse(JSON.stringify(this.localValue));
    newValue.push({
      recipient: null,
      purpose: null,
      recipientType: null,
      extraUe: false,
      guarantees: [],
      country: null
    });
    this.changeValue.emit(this.localValue);
    this.localValue = newValue;
    this.rows = this.localValue;
    this.align();
  }

}
